import { render, staticRenderFns } from "./txnAnalysisReport.vue?vue&type=template&id=4648953a&scoped=true"
import script from "./txnAnalysisReport.vue?vue&type=script&lang=js"
export * from "./txnAnalysisReport.vue?vue&type=script&lang=js"
import style0 from "./txnAnalysisReport.vue?vue&type=style&index=0&id=4648953a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648953a",
  null
  
)

export default component.exports